import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import styles from './UnattendedGearIsNotCovered.module.css';
import { FormattedMessage, intlShape, injectIntl } from '../../../util/reactIntl';

export default function UnattendedGearIsNotCovered({ handleUnattendedGear }) {
  const [isChecked, setIsChecked] = useState(false);
  const handleClick = e => {
    setIsChecked(e.target.checked);
    handleUnattendedGear();
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title} id="warning-title">
          <FormattedMessage id={'UnattendedGearIsNotCovered.title'} />
        </h2>
      </div>
      <div className={styles.content}>
        <label className={styles.label}>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleClick}
            className={styles.checkbox}
            aria-describedby="agreement-description"
          />
          <span className={styles.agreementText} id="agreement-description">
            <FormattedMessage id={'UnattendedGearIsNotCovered.agreement'} />
          </span>
        </label>
        {!isChecked && (
          <p className={styles.description}>
            <FormattedMessage id={'UnattendedGearIsNotCovered.content'} />
            <a target="_blance" href="/terms-of-service" className={styles.link}>
              <FormattedMessage id={'UnattendedGearIsNotCovered.termsOfService'} />
            </a>{' '}
            <FormattedMessage id={'UnattendedGearIsNotCovered.coverageExclusions'} />
          </p>
        )}
      </div>
    </div>
  );
}
